<template>
  <div>
    <template v-if="contents">
      <div :class="['component', previewSize]" :style="hideAll ? 'display:none' : ''">
        <div @click="isEditing = !isEditing">

          <section :class="sectionClassArray" :style="sectionStyle">
            <div :class="containerClassArray">
              <div class="slide-header flex justify-between items-end">
                <h2 class="slide-h2 m0">{{ contents.heading.text }}</h2>
                <a class="slide-header-a flex justify-center items-center">一覧をみる<i class="fa fa-angle-right" aria-hidden="true"></i></a>
              </div>
              <div class="slide-list">
                <template v-for="(post, index) in posts">
                  <template v-if="index < contents.perPage">
                    <article class="slide-item">
                      <span class="slide-a flex items-center py1">
                        <template v-if="post.featured_media">
                          <mimic-amp-img class="slide-thumbnail shrink-0" :style="getEyecatchSize()" :image="getFeaturedMedia(post.featured_media)"></mimic-amp-img>
                        </template>
                        <template v-else>
                          <div class="slide-thumbnail no-image shrink-0 flex justify-center items-center" :style="getEyecatchSize()">NO IMAGE</div>
                        </template>
                        <div class="flex column  ml2">
                          <time class="slide-published m0">{{ dateFormat(post.date) }}</time>
                          <h3 class="slide-title m0 pt1">{{ post.title.rendered }}</h3>
                        </div>
                      </span>
                    </article>
                  </template>
                </template>
              </div>
            </div>
          </section>

        </div>
      </div>
      <el-form :class="['component-contents-form', ' p2', lock ? 'hide' : isEditing ? 'show' : 'hide']" :model="contents">
        <h2>コンポーネントのコンテンツを編集</h2>
        <el-form-item label="コンポーネント配置順序" label-width="170px">
          <el-input-number v-model="newPosition" controls-position="right" :min="1" :max="positionMax"></el-input-number><span style="pl4">1から{{ positionMax }}まで</span>
        </el-form-item>
        <el-form-item label="見出し" :label-width="labelWidth">
          <el-input type="textarea" :autosize="{minRows:2}" v-model="contents.heading.text" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="投稿の表示数" :label-width="labelWidth">
          <el-input type="number" v-model="contents.perPage" :min="1" :max="50" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="アイキャッチ画像の最大幅 (px)" :label-width="labelWidth">
          <el-input type="number" v-model="contents.eyecatch.maxWidth" :min="100" :max="300" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="スライド上下の余白" :label-width="labelWidth">
           <el-slider v-model="contents.padding.y" :step="1" :min="0" :max="10"></el-slider>
        </el-form-item>
        <el-form-item label="スライド背景色" :label-width="labelWidth">
          <div>
            <el-checkbox v-model="contents.bg.isCustom">スライドの背景色を指定する</el-checkbox>
          </div>
          <div class="items-center" :style="{display: contents.bg.isCustom ? 'flex' : 'none'}">
            <el-color-picker v-model="contents.bg.color" show-alpha></el-color-picker>
            <span>{{ contents.bg.color }}</span>
          </div>
        </el-form-item>
        <div class="component-contents-controller flex justify-end items-center">
          <component-form-footer @delete="deleteComponent()" @cancel="isEditing = false" @update="updateComponent()"></component-form-footer>
        </div>
      </el-form>
    </template>
  </div>
</template>

<script>
import ComponentBase from '@/components/mixins/ComponentBase'
import MimicAmpImg from '@/components/mimic-amp/MimicAmpImg'
import * as moment from 'moment'

export default {
  name: 'post-list-1',
  mixins: [ComponentBase],
  components: {
    'mimic-amp-img': MimicAmpImg
  },
  data: function () {
    return {
      labelWidth: '120px'
    }
  },
  methods: {
    dateFormat (date) {
      return moment(date).format('YYYY年M月D日')
    },
    getEyecatchSize: function (flag) {
      // migration
      if (!this.contents.eyecatch) this.contents.eyecatch = { maxWidth: 100 }

      const style = `width:${this.contents.eyecatch.maxWidth}px;height:${this.contents.eyecatch.maxWidth}px;max-width:${this.contents.eyecatch.maxWidth}px;max-height:${this.contents.eyecatch.maxWidth}px;`
      return flag === 'media' ? `@media(min-width:768px){.${this.meta.file} .slide-thumbnail {${style}}}` : style
    },
    getFeaturedMedia: function (id) {
      const featured = this.media.find(image => image.id === id)
      return {
        id: featured.id,
        src: featured.media_details.sizes.thumbnail.source_url,
        width: featured.media_details.sizes.thumbnail.width,
        height: featured.media_details.sizes.thumbnail.height
      }
    },
    /**
     * this.contentsからコンポーネントのHTMLを生成
     */
    generateHtml: function (contents) {
      return `
      <section id="${this.sectionId}" class="${this.sectionClass}">
        <div class="${this.containerClass}">
          [PostList1 per_page="${contents.perPage}" heading="${contents.heading.text}"]
        </div>
      </section>
      `.trim().replace(/>\s+</g, '><')
    },
    /**
     * this.contentsからコンポーネントのCSSを生成
     */
    generateCss: function (contents) {
      let layout = require(`!css-to-string-loader!css-loader?minimize!sass-loader!./${this.meta.file}.scss`)
      layout += this.getEyecatchSize('media')
      let theme = contents.bg.isCustom ? `.${this.meta.file}-${this._uid}-bg{background-color:${contents.bg.color}}` : ''
      return {layout, theme}
    }
  },
  created: async function () {
    if (!this.posts.length) await this.$store.dispatch('wordpress/posts/fetch')

    // migration
    if (!this.contents.eyecatch) this.contents.eyecatch = { maxWidth: 100 }
    // migration
    if (!this.contents.padding) this.contents.padding = {y: 4}
  }
}
</script>

<style lang="scss" scoped>
.native {
  @import './PostList1.scss';
}
.smartphone,
.tablet,
.desktop {
  @import './PostList1.s.scss';
}
.tablet,
.desktop {
  @import './PostList1.m.scss';
}
.desktop {
  @import './PostList1.l.scss';
}
</style>


// WEBPACK FOOTER //
// src/components/contents/PostList1/PostList1.vue